import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon, MinusIcon } from 'lucide-react';
const features = [{
  name: 'AI Agenda Generation',
  diy: false,
  other: false,
  offsite: true
}, {
  name: 'Live Attendee App',
  diy: false,
  other: true,
  offsite: true
}, {
  name: 'Real-time Analytics',
  diy: false,
  other: 'Partial',
  offsite: true
}, {
  name: 'Post-event ROI Report',
  diy: false,
  other: false,
  offsite: true
}, {
  name: 'Learning Pathways',
  diy: false,
  other: false,
  offsite: true
}, {
  name: 'World-class Content Library',
  diy: false,
  other: false,
  offsite: true
}, {
  name: 'Smart Group Formation',
  diy: 'Manual',
  other: false,
  offsite: true
}, {
  name: 'Fully Branded Experience',
  diy: false,
  other: 'Partial',
  offsite: true
}];
function StatusIcon({
  status
}: {
  status: boolean | string;
}) {
  if (status === true) {
    return <CheckIcon className="w-5 h-5 text-brand-teal mx-auto" data-id="element-541" />;
  }
  if (status === false) {
    return <XIcon className="w-5 h-5 text-slate-300 mx-auto" data-id="element-542" />;
  }
  if (status === 'Partial' || status === 'Manual') {
    return <div className="flex items-center justify-center gap-1.5 text-slate-400 text-sm font-medium" data-id="element-543">
        <MinusIcon className="w-4 h-4" data-id="element-544" />
        {status}
      </div>;
  }
  return null;
}
export function ComparisonTable() {
  return <section className="py-24 px-6 md:px-10 bg-white" data-id="element-545">
      <div className="max-w-5xl mx-auto" data-id="element-546">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-547">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-548">
            <h2 className="text-3xl md:text-5xl font-bold text-brand-navy mb-4 tracking-tight" data-id="element-549">
              Why teams choose <span className="text-brand-teal" data-id="element-550">Offsite+</span>
            </h2>
            <p className="text-lg text-slate-600" data-id="element-551">
              Stop duct-taping spreadsheets, generic event apps, and Slack
              channels together.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="relative" data-id="element-552">
          {/* Highlight background for Offsite+ column */}
          <div className="absolute top-0 bottom-0 right-0 w-1/3 md:w-1/4 bg-brand-teal/[0.03] rounded-2xl border-2 border-brand-teal/20 -z-10 scale-[1.02] shadow-lg shadow-brand-teal/5" data-id="element-553" />

          <div className="overflow-x-auto" data-id="element-554">
            <table className="w-full text-left border-collapse" data-id="element-555">
              <thead data-id="element-556">
                <tr data-id="element-557">
                  <th className="p-4 md:p-6 text-sm md:text-base font-semibold text-slate-400 w-2/5 md:w-1/4" data-id="element-558">
                    Capabilities
                  </th>
                  <th className="p-4 md:p-6 text-center text-sm md:text-base font-bold text-slate-600 w-1/5 md:w-1/4" data-id="element-559">
                    DIY
                    <br data-id="element-560" />
                    <span className="text-xs font-normal text-slate-400" data-id="element-561">
                      (Spreadsheets)
                    </span>
                  </th>
                  <th className="p-4 md:p-6 text-center text-sm md:text-base font-bold text-slate-600 w-1/5 md:w-1/4" data-id="element-562">
                    Other Tools
                    <br data-id="element-563" />
                    <span className="text-xs font-normal text-slate-400" data-id="element-564">
                      (Generic Apps)
                    </span>
                  </th>
                  <th className="p-4 md:p-6 text-center text-lg md:text-xl font-bold text-brand-teal w-1/5 md:w-1/4" data-id="element-565">
                    Offsite+
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-566">
                {features.map((feature, i) => <tr key={feature.name} className="border-t border-slate-100 group hover:bg-slate-50/50 transition-colors" data-id="element-567">
                    <td className="p-4 md:p-6 text-sm md:text-base font-medium text-brand-navy" data-id="element-568">
                      {feature.name}
                    </td>
                    <td className="p-4 md:p-6 text-center" data-id="element-569">
                      <StatusIcon status={feature.diy} data-id="element-570" />
                    </td>
                    <td className="p-4 md:p-6 text-center" data-id="element-571">
                      <StatusIcon status={feature.other} data-id="element-572" />
                    </td>
                    <td className="p-4 md:p-6 text-center bg-brand-teal/[0.02] group-hover:bg-brand-teal/[0.04] transition-colors rounded-lg" data-id="element-573">
                      <StatusIcon status={feature.offsite} data-id="element-574" />
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </motion.div>
      </div>
    </section>;
}